// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
  background-color: var(--primaryColor);
  width: 100%;
}

.footer-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 6rem;
  padding-bottom: 8rem;
  justify-content: center;
}
.footer-content li {
  color: white;
}
.footer-content li:hover {
  color: var(--secondaryColor) !important;
  transition: color 1s;
}
/* .footer-content:after {
  content: '';
  position: absolute;
  width: 100%;
  transform: scaleX(0.2);
  height: 4px;
  bottom: 0;
  left: 0;
  background-color: var(--secondaryLightColor) !important;
  transform-origin: bottom right;
  transition: transform 0.5s ease-out;
}
.footer-content:hover:after {
  transform: scaleX(1) !important;
  transform-origin: bottom left;
} */
.footer-left {
  display: flex;
  flex-direction: column;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 11rem;
}
.footer-left h5,
h6 {
  margin: 0;
  color: white !important;
}

.footer-right {
  display: flex;
  flex-direction: column;
  margin-left: 8rem;
  margin-right: 4rem;
}
.footer-right h5,
h6 {
  margin: 0;
  color: white;
}

.footer-ul-left {
  display: flex;
  flex-direction: column;
  margin-right: 8rem;
}
.footer-ul-right {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  margin-right: 0;
}
.footer-ul-right h5 {
  margin-bottom: 1rem;
}
.footer-ul-right li {
  margin: 0.3rem 0;
}

.footer-ul-left h5 {
  margin-bottom: 1rem;
}
.footer-ul-left li {
  margin: 0.3rem 0;
}

.bottom-line {
  height: 2px;
  background-color: var(--secondaryColor);
  border: none;
  margin: 0;
}

.footer-link-to-rio {
  color: white;
  text-decoration: none;
  padding-top: 1rem;
}
@media only screen and (max-width: 767px) {
  .footer-content {
    flex-direction: column;
    align-items: flex-start;
    margin-left: 2rem;
  }
  .footer-left {
    margin-left: 0;
    padding-left: 0;
    margin-right: 0;
    align-items: center;
  }
  .footer-right {
    margin-left: 0;
    margin-right: 0;
    align-items: center;
  }
  .footer-ul-left {
    margin-left: 0;
    margin-right: 7.5rem;
  }
  .footer-ul-right {
    margin-left: 0;
    margin-right: 0;
  }
  .footer-right h5 {
    margin: 2rem auto 1rem 0;
  }
  .footer-left h5 {
    margin: 2rem auto 1rem 0;
  }
  .bottom-line {
    width: 60%;
  }
}
@media only screen and (max-width: 992px) {
  .footer-content {
    margin-top: 6rem;
  }
  .footer-right {
    margin-left: 0;
    margin-right: 0;
    align-items: center;
  }
  .footer-right {
    margin-left: 0;
  }
  .footer-ul-right {
    margin-left: 0;
    margin-right: 0;
  }
}

/*.footer-gradient {
   background: linear-gradient(-45deg, var(--secondaryColor), #faf0e6, #faf0e6, var(--secondaryColor));
  background-size: 400% 400%;
  animation: gradient 15s ease infinite; 
  height: auto;
}*/
`, "",{"version":3,"sources":["webpack://./src/css/footer.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;AACA;;;;;;;;;;;;;;;GAeG;AACH;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;;;;;EAKE","sourcesContent":[".footer-container {\n  background-color: var(--primaryColor);\n  width: 100%;\n}\n\n.footer-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 6rem;\n  padding-bottom: 8rem;\n  justify-content: center;\n}\n.footer-content li {\n  color: white;\n}\n.footer-content li:hover {\n  color: var(--secondaryColor) !important;\n  transition: color 1s;\n}\n/* .footer-content:after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  transform: scaleX(0.2);\n  height: 4px;\n  bottom: 0;\n  left: 0;\n  background-color: var(--secondaryLightColor) !important;\n  transform-origin: bottom right;\n  transition: transform 0.5s ease-out;\n}\n.footer-content:hover:after {\n  transform: scaleX(1) !important;\n  transform-origin: bottom left;\n} */\n.footer-left {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0.2rem;\n  margin-right: 0.2rem;\n  margin-left: 11rem;\n}\n.footer-left h5,\nh6 {\n  margin: 0;\n  color: white !important;\n}\n\n.footer-right {\n  display: flex;\n  flex-direction: column;\n  margin-left: 8rem;\n  margin-right: 4rem;\n}\n.footer-right h5,\nh6 {\n  margin: 0;\n  color: white;\n}\n\n.footer-ul-left {\n  display: flex;\n  flex-direction: column;\n  margin-right: 8rem;\n}\n.footer-ul-right {\n  display: flex;\n  flex-direction: column;\n  margin-left: 0;\n  margin-right: 0;\n}\n.footer-ul-right h5 {\n  margin-bottom: 1rem;\n}\n.footer-ul-right li {\n  margin: 0.3rem 0;\n}\n\n.footer-ul-left h5 {\n  margin-bottom: 1rem;\n}\n.footer-ul-left li {\n  margin: 0.3rem 0;\n}\n\n.bottom-line {\n  height: 2px;\n  background-color: var(--secondaryColor);\n  border: none;\n  margin: 0;\n}\n\n.footer-link-to-rio {\n  color: white;\n  text-decoration: none;\n  padding-top: 1rem;\n}\n@media only screen and (max-width: 767px) {\n  .footer-content {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-left: 2rem;\n  }\n  .footer-left {\n    margin-left: 0;\n    padding-left: 0;\n    margin-right: 0;\n    align-items: center;\n  }\n  .footer-right {\n    margin-left: 0;\n    margin-right: 0;\n    align-items: center;\n  }\n  .footer-ul-left {\n    margin-left: 0;\n    margin-right: 7.5rem;\n  }\n  .footer-ul-right {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .footer-right h5 {\n    margin: 2rem auto 1rem 0;\n  }\n  .footer-left h5 {\n    margin: 2rem auto 1rem 0;\n  }\n  .bottom-line {\n    width: 60%;\n  }\n}\n@media only screen and (max-width: 992px) {\n  .footer-content {\n    margin-top: 6rem;\n  }\n  .footer-right {\n    margin-left: 0;\n    margin-right: 0;\n    align-items: center;\n  }\n  .footer-right {\n    margin-left: 0;\n  }\n  .footer-ul-right {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n/*.footer-gradient {\n   background: linear-gradient(-45deg, var(--secondaryColor), #faf0e6, #faf0e6, var(--secondaryColor));\n  background-size: 400% 400%;\n  animation: gradient 15s ease infinite; \n  height: auto;\n}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
